export default {
  apiRoot: "/api",
  debug: true,
  testing: true
};
